import { useEffect, useState } from 'react';

import useApi from '../actions/useApi';
import { useStateContext } from '../store/stateContext';

const useMouseTracking = () => {
  const [startTime, setStartTime] = useState(null);
  const { state } = useStateContext();
    const { updateInteractionTime } = useApi();

  const onInteractionEndCallback = (elapsedTime: number) => {
    console.log('User interacted with the widget for', elapsedTime, 'ms');
    updateInteractionTime(Number(state.productInfo?.id), elapsedTime);
  };
  const handleInteractionStart = () => {
    if (startTime === null) {
      // Start the timer when interaction starts
      setStartTime(Date.now() as any);
    }
  };

  const handleInteractionEnd = () => {
    if (startTime !== null) {
      // Calculate the elapsed time
      const elapsedTime = Date.now() - startTime;
      // Call the provided callback with elapsed time
      onInteractionEndCallback(elapsedTime);
      // Reset the timer
      setStartTime(null);
    }
  };

  useEffect(() => {
    const widget = document.getElementById('widget');
    if (widget) {
      // Mouse events
      widget.addEventListener('mouseenter', handleInteractionStart);
      widget.addEventListener('mouseleave', handleInteractionEnd);

      // Touch events
      widget.addEventListener('touchstart', handleInteractionStart);
      widget.addEventListener('touchend', handleInteractionEnd);
    }

    return () => {
      if (widget) {
        // Mouse events
        widget.removeEventListener('mouseenter', handleInteractionStart);
        widget.removeEventListener('mouseleave', handleInteractionEnd);

        // Touch events
        widget.removeEventListener('touchstart', handleInteractionStart);
        widget.removeEventListener('touchend', handleInteractionEnd);
      }
    };
  }, [onInteractionEndCallback]);

  return;
};

export default useMouseTracking;
